import { Focused } from "@/components/core-components/templates/Focused/focused";
import { ManageMembersLoading } from "../ManageMembersLoading/manage-members-loading";
import { ProgressBarFullWidth } from "@/components/core-components";
import { Skeleton } from "@flash-tecnologia/hros-web-ui-v2";

export const WorkflowLoading = ({ title }: { title?: string }) => (
  <Focused.Root fullScreen>
    <Focused.Header>
      {title && <Focused.Title color="neutral.30">{title}</Focused.Title>}
      {!title && <Skeleton variant="text" width="160px" />}
    </Focused.Header>
    <ProgressBarFullWidth.Root>
      <ProgressBarFullWidth.ActiveBar percent={0} />
      <ProgressBarFullWidth.GuideLine />
    </ProgressBarFullWidth.Root>
    <Focused.Main>
      <ManageMembersLoading />
    </Focused.Main>
    <Focused.Footer>
      <Skeleton height="40px" width="160px" />
      <Skeleton height="40px" width="160px" />
    </Focused.Footer>
  </Focused.Root>
);
